export function Constants() {
  angular.module("classkickApp").constant("constants", {
    version: "5.288.0-ab32601",
    backend: "webservices",
    projectId: "classkick-907",
  })
}
